import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_53: FaireProductEntity = {
  token: "legacy_prod_abbott-53",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3cd4544ae25caeae29bd66fe1c27d20be3112e284bf510f2b1018bcef544132f.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
